import { q } from '../helper/q'

const config = {
  threshold: 0.5,
}
export const animateInit = () => {
  const observer = new IntersectionObserver(changes => {
    changes.forEach(change => {
      if (change.intersectionRatio > 0.5) {
        q('svg', change.target).classList.add('active')
        observer.unobserve(change.target)
      }
    })
  }, config)

  const valueEl = q('.pageAboutValues')
  observer.observe(valueEl)
}
